import { z } from '../zod.js';
import { ObjectIdStringValidationSchema } from '../shared/ObjectId';
import { CANCEL_PAYMENT_REFUND_REASONS } from '../payment/cancel';

export const CancelTicketsRequestBodyValidationSchema = z
  .object({
    ticketIds: z.array(ObjectIdStringValidationSchema).min(1),
    reason: z.string().max(500),
    sendCancellationEmail: z.boolean().optional(),
    refund: z
      .object({
        amount: z.number().int().positive(),
        reason: z.enum(CANCEL_PAYMENT_REFUND_REASONS),
        note: z.string().max(500).optional(),
      })
      .strict()
      .optional(),
  })
  .strict();
export type CancelTicketsRequestBody = z.infer<typeof CancelTicketsRequestBodyValidationSchema>;

export const CancelTicketsResponseValidationSchema = z.object({
  canceledTicketIds: z.array(z.string()),
  bookingCanceled: z.boolean(),
});
export type CancelTicketsResponse = z.infer<typeof CancelTicketsResponseValidationSchema>;
